import type { AccessPrivilege } from '@stopal/shared/access-privilege'
import { useQuery } from '@tanstack/react-query'
import { hasGate } from '@/lib/nexus/sections'
import { trpc } from '@/trpc/client'

export function RequirePrivilege({
  anyOf,
  children,
}: {
  anyOf: readonly AccessPrivilege[]
  children: React.ReactNode
}) {
  const { data: me, isLoading } = useQuery(trpc.user.me.queryOptions())

  if (isLoading) {
    return <div className="p-6 text-sm text-text-muted">Loading…</div>
  }

  const privileges = me?.privileges ?? []
  const admitted = anyOf.some((privilege) =>
    hasGate(privilege, privileges, me?.role),
  )

  if (!admitted) {
    return (
      <div className="p-6 text-sm text-text-muted">
        You do not have access to this page. An administrator can grant access.
      </div>
    )
  }

  return <>{children}</>
}
